(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuft-product-conversion"] && !Shopify.designMode) return;
  try {
    
  const mobileForm = document.querySelector('#tc-mobile-product-form');
  const proPage = document.querySelector('.tc-pro-benefits');

  if (proPage) {
    const productTitle = document.querySelector('.product__title');
    if (productTitle && !document.querySelector('.tc-pro-hero-copy')) {
      const firstKit = proPage.dataset.kit === 'first';
      const studioKit = proPage.dataset.kit === 'studio';
      const gunPage = proPage.dataset.kit === 'gun';
      const gunColour = proPage.dataset.colour || '';
      const heroHeadline = firstKit
        ? 'Make your first rug at home—with the essentials already sorted.'
        : studioKit
          ? 'Create larger rugs at home—with a complete studio-ready setup.'
          : gunPage
            ? 'Start tufting with steady control—not unnecessary complexity.'
            : 'Build professional-quality rugs at home—with one complete setup.';
      const heroSummary = firstKit
        ? 'A beginner-ready tufting gun, practical frame, starting materials and clear guidance in one kit.'
        : studioKit
          ? 'The Tuft & Craft Studio Pro Kit pairs a 115 × 115 cm metal frame with 14 essential tools and materials for committed makers who want more space and cleaner finishing.'
          : gunPage
            ? `The $309 ${gunColour} AK‑V Pro gives beginners adjustable speed, a digital LED display and one clear choice: cut pile or loop pile.`
            : 'Compatible studio-tested tools, a spacious metal frame, finishing equipment and beginner guidance in one kit.';
      productTitle.insertAdjacentHTML('afterend', `
        <div class="tc-pro-hero-copy">
          <strong>${heroHeadline}</strong>
          <p>${heroSummary}</p>
        </div>
      `);
    }

    document.querySelectorAll('.tc-scroll-buy').forEach((button) => {
      button.addEventListener('click', () => {
        document.querySelector('.product-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (mobileForm) {
    mobileForm.addEventListener('submit', () => {
      const sourceInput = document.querySelector('product-form form input[name="id"]');
      const mobileInput = mobileForm.querySelector('input[name="id"]');

      if (sourceInput && mobileInput) {
        mobileInput.value = sourceInput.value;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
